import classNames from 'classnames'
import { useApp } from '../../../hooks/useApp'

interface Props {
  className?: string
}

export const CarabinerMainProductVariants = ({ className }: Props) => {
  const {
    mainProduct,
    activeMainProductVariantId,
    setActiveMainProductVariantId,
    setPreviewPendantProductVariantId
  } = useApp()

  return (
    <ul
      className={classNames(
        'flex gap-3 xl-max:overflow-x-auto xl:grid xl:grid-cols-6 2xl:grid-cols-9 xl:w-fit',
        className
      )}
    >
      {mainProduct.variants.map((mainProductVariant) => {
        const isSelectedVariant = String(activeMainProductVariantId) === String(mainProductVariant.id)
        const imageUrl = mainProductVariant.metafields.previewButtonThumbnail || mainProductVariant.featuredImageUrl || mainProductVariant.featured_image.src || mainProduct.featured_image
        const title = mainProductVariant.metafields.title || mainProductVariant.title

        return (
          <li
            key={mainProductVariant.id}
            className={classNames(
              'shrink-0 w-[40px] xl:w-[48px] h-[40px] xl:h-[48px] border',
              isSelectedVariant ? 'border-subdued' : 'border-transparent'
            )}
          >
            <button
              aria-label={title}
              aria-pressed={isSelectedVariant}
              className={classNames(!mainProductVariant.available && 'opacity-30', 'relative block w-full h-full')}
              onClick={() => {
                setPreviewPendantProductVariantId(null)
                setActiveMainProductVariantId(String(mainProductVariant.id))
              }}
              title={title}
              type="button"
            >
              <img className="w-full h-full object-cover" src={imageUrl} alt={title} width="50" height="50" />
            </button>
          </li>
        )
      })}
    </ul>
  )
}